import { cx } from '../lib/cx';

interface BooleanFieldProps {
  id: string;
  label: string;
  hint?: string;
  value: boolean | undefined;
  onChange: (v: boolean) => void;
}

/**
 * Yes and no as two full-size buttons rather than a checkbox or a toggle.
 * A committee member on a phone should not have to hit a 20px switch, and an
 * unanswered question stays visibly unanswered instead of defaulting to "no".
 */
export default function BooleanField({ id, label, hint, value, onChange }: BooleanFieldProps) {
  const hintId = hint ? `${id}-hint` : undefined;

  return (
    <fieldset className="flex flex-col gap-2 border-0 p-0">
      <legend className="t-h3 text-ink">{label}</legend>
      {hint && (
        <p id={hintId} className="t-meta measure text-grey-600">
          {hint}
        </p>
      )}
      <div className="mt-1 flex flex-wrap gap-2" aria-describedby={hintId}>
        {[
          { v: true, label: 'Yes' },
          { v: false, label: 'No' },
        ].map((o) => {
          const selected = value === o.v;
          return (
            <button
              key={o.label}
              type="button"
              aria-pressed={selected}
              onClick={() => onChange(o.v)}
              className={cx(
                'min-h-tap min-w-28 rounded-full border px-6 text-[0.95rem] transition-colors',
                selected
                  ? 'border-green-600 bg-green-050 font-semibold text-green-900 shadow-[inset_0_0_0_2px_var(--color-green-600)]'
                  : 'border-grey-300 bg-white text-ink hover:bg-grey-050',
              )}
            >
              {o.label}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
